import { Button, Tooltip, utility } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';
import { ISubscriptions } from '..';

export const SubscriptionButton = defineComponent({
    props: {
        subscriptions: {
            required: true,
            type: Object as PropType<ISubscriptions>,
        },
    },

    setup(props) {
        const { subscriptions } = props;

        function text() {
            switch (subscriptions.state.subscription_status.value) {
                case 'educational':
                    return 'Edu';

                case 'full':
                case 'full_onshape':
                        return 'Professional';

                case 'starter':
                    return 'Essentials';

                case 'free':
                    return 'Renew Plan';

                case 'trial': {
                    console.log("P7:")
                    console.log(subscriptions.state.trial_days_left())
                    const days = subscriptions.state.trial_days_left();
                    console.log("P8:")
                    console.log(days)
                    switch (days) {
                        case 1: return 'Last day!';
                        default: return `${days} days left`;
                    }
                }

                default:
                    return 'Expired';
            }
        }

        function onClick() {
            if (subscriptions.state.subscription_status.value === undefined) {
                subscriptions.show_select_a_subscription_page();
            } else {
                subscriptions.stripe.open_store();
            }
        }

        return () => h(Tooltip, {
            placement: 'left',
        }, {
            default: () => h(Button, {
                class: {
                    [utility.small]: subscriptions.state.subscription_status.value === 'trial',
                },
                variant: 'primary',
                onClick,
            }, text),

            tooltip: h('div', { innerHTML: '<h4>Your Subscription</h4><p>Click to manage your subscription.</p>' }),
        });
    },
});
